import { Injectable } from '@angular/core';

import { TreeNode } from 'primeng/api';

import { IncludeOrExclude } from '../../Dialogs/services/data-select-dialog.service.interface';
import { LanguageSelectDialogService } from '../../Dialogs/services/language-select-dialog.service';
import { LocalizationService } from '../../../Core/Localization/services/localization.service';
import { LanguageModel } from '../../../Core/Localization/models/language.model';

@Injectable()
export class TargetingSearchLanguageSelectDialogService extends LanguageSelectDialogService {

    selectedLanguages: LanguageModel[] = [];

    constructor(
        protected localizationService: LocalizationService,
    ) {
        super(localizationService);
    }

    applySelectedListItems(selectedItems: TreeNode[]): void {
        this.selectedLanguages = [];
        for (const selectedItem of this.selectedListItems) {
            this.selectedLanguages.push(<LanguageModel>selectedItem.data);
        }
    }

    public setAppropriateListItems(): void {
        if (this.state === undefined) {
            return;
        }

        this.selectedListItems = this.mapSelectedLanguagesToNodes(this.selectedLanguages);
        this.selectedDataItems = this.selectedListItems;
        this.updateSelectedTypes();
        this.selectedListItemProvider.next(this.selectedListItems);
        this.selectedDataItemsProvider.next(this.selectedDataItems);
    }

    prepareData(state: IncludeOrExclude, languageIds: string[]) {
        this.localizationService.getLanguagesById(languageIds).subscribe(languages => {
            this.selectedLanguages = languages;
            this.setState(state);
        });
    }

    prepareModelData(state: IncludeOrExclude, languages: LanguageModel[]) {
        this.selectedLanguages = languages;
        this.setState(state);
    }
}
